// 根据 登录获取用户信息
import { apiGet, apiPost, apiPatch, apiDelete } from './index'
const loginAuthUrl = `${process.env.baseURL}/openapi/iep/login`
/*
 * /openapi/iep/qr/scan/{random}/{status}
 */
const getQrCode = (params) => apiGet(`/api/openapi/iep/qr/scan/${params.random}/${params.status}`)

const systemRedisGet = (params) => apiGet(`/api/system/redis/${params.key}`)
const systemRedisSet = (params) => apiPost(`/api/system/redis/${params.key}/${params.value}`)
const systemRedisDelete = (params) => apiDelete(`/api/system/redis/${params.key}`)
const login = (params) => apiPost('/api/auth/login/iep', params)
const queryPermissionsByUser = (params) => apiGet('/api/auth/user/current', params)
// 分享埋点
const sourceShare = (params) => apiPost('/api/sys/share', params)
// iep登录判断
const getIsJinxiuAuthNew = (params) => apiGet(`/api/openapi/iep/getIsJinxiuAuthNew/${params.iepLoginId}`)

/**
 * 申诉
 * 1、调sys-files/mainId get请求  获取ID
 * 2、上传图片的时候调用 uploadFile/{mainId}  post请求
 * 3、保存的时候调用 appealRecord post请求，将第一步的ID 传入到 id字段
 */
const sysFiles = () => apiGet(`/api/sys-files/mainId`)
const uploadFile = (mainId, params) => apiPost(`/api/sys-files/uploadFile/${mainId}`, params, true)
const appealRecord = (params) => apiPost('/api/appealRecord', params)
// 获取首页banner
const getBanner = (params) => apiGet('/api/johnson/banners/myList', params)
// 我的学习列表
const getStudyOverview = (params) => apiGet('/api/journeys/myList', params)
// 学习地图
const getStudyMap = (params) => apiGet(`/api/journeys/${params.journeyId}/userid/${params.userId}`, params)
// 查询课程详情
const getDatabaseCoursesDetail = (params) => apiGet(`/api/courses/findCourseInfoById/${params.courseId}`, params)
// 查看课程详情，当前视频的弹幕
const getBarrage = (params) => apiGet(`/api/course/sections/barrage/section/list`, params)
// 视频发送弹幕
const sendBarrage = (params) => apiPost('/api/course/sections/barrage', params)

// 视频观看记录
const postVideoRecords = (params) => apiPost('/api/course/completed/records', params)
// 视频评价
const videoFeedbacks = (params) => apiPost('/api/course/feedbacks', params)
// 提交反馈
const sendFeedback = (params) => apiPost('/api/system/feedback', params)
// 旅程阶段升级弹窗
const getJourneyUpdateData = (params) => apiGet(`/api/johnson/hcpupgrade/${params.multiCode}`, params)
// 弹窗后修改状态
const modifyPopupState = (params) => apiPatch(`/api/johnson/hcpupgrade/${params.multiCode}`, params)
// 获取旅程阶段信息 过关标准
const getJourneyStageData = (params) => apiGet(`/api/journey/stages/getJourneyStage`, params)
// 获取专业支持当前旅程、阶段
const getJourneyReport = (params) => apiGet(`/api/hcp/journey/reports/report/multicode/${params.multiCode}`, params)
// 获取旅程阶段任务
const getStageTask = (params) => apiGet(`/api/hcp/journey/reports/report/task/getTaskReport`, params)
// 获取活动列表
const getActivityList = (params) => apiGet(`/api/training/academic/activities/mobile`, params)
// 获取每日一题
const getDaily = (params) => apiGet(`/api/question/daily`, params)
// 提交答案
const questionUser = (params) => apiPost('/api/question/user', params)

const getIsCorrect = (params) => apiGet(`/api/question/user/isCorrect/${params.userId}/${params.questionId}`, params)
// 直播列表
const getLiveList = (params) => apiGet(`/api/live/listPageMobile`, params)
// 直播预约
const liveMake = (params) => apiGet(`/api/liveJoinrecord/makeStatus`, params)
const liveGetInfoById = (params) => apiGet(`/api/live/getInfoById/${params.liveId}`, params)

// 直播地址code
const getUserAESCode = (params) => apiGet(`/api/johnson/iep/users/getUserAESCode/${params.userId}`, params)
// ILive新直播地址code
const getUserAESCodeV2 = (params) => apiGet(`/api/johnson/iep/users/getUserAESCodeV2/${params.userId}`, params)

// 你有一条未读的活动报告
const selectActivityRead = (params) => apiGet(`/api/training/academic/activityUserRead/selectActivityRead/${params.userId}`)
// 手术报告设置为已读
const updateIsRead = (params) => apiPatch(`/api/hcp/operation/reports/updateIsRead/${params.operationId}`, params)
// 你有一条未读的学术报告
const selectReportsRead = (params) => apiGet(`/api/hcp/operation/reports`, params)
// 你有一条未读的学术报告 AIFV
const getAifvPushRecordIsRead = (params) => apiGet(`/api/aifvPushRecord/getAifvPushRecordIsRead/${params.multiCode}`, params)

// 搜索接口
const homeSearch = (params) => apiPost(`/api/userSearchLog/homeSearch`, params)
// 搜索接口AI
const homeSearchAI = (params) => apiGet(`/api/openapi/iep/getRobotRecommend`, params)
// 根据ID获取cover图
const getListBylakehouseId = (params) => apiPost(`/api/docuCourseCaseHc/getListBylakehouseId`, params)
// 为你推荐
const homeRecommend = (params) => apiGet(`/api/userSearchLog/homeRecommend`, params)
// 热门精选
const homeHot = (params) => apiGet(`/api/userSearchLog/homeHot`, params)
// 最新上架
const homeNewest = (params) => apiGet(`/api/userSearchLog/homeNewest`, params)
// 最新上架
const recommendTips = (params) => apiPatch(`/api/johnson/iep/users/recommendTips/${params.userId}`, params)

// 课程热门推荐
const similarRecommend = (params) => apiGet(`/api/userSearchLog/similarRecommend`, params)

// 学习报告
const getLearningReport = (params) => apiGet(`/api/userSearchLog/getLearningReport`, params)

// 我的消息
const iepXxbCaseMessages = (params) => apiGet(`/api/system/iepXxbCaseMessages`, params)

// 设置消息已读
const updateIepXxbCaseMessagesIsRead = (id) => apiPost(`/api/system/iepXxbCaseMessages/updateIepXxbCaseMessagesIsRead/${id}`)

// 注销用户
const iepLogout = (params) => apiGet(`/api/openapi/iep/iepLogout`, params)

// 弹幕列表
const barrageList = (params) => apiGet(`/api/course/barrage/wording/valid/list`, params)

// 收藏课程
const userCollect = (params) => apiPost('/api/userCollect', params)

// 取消收藏课程
const cancelUserCollect = (params) => apiPost(`/api/userCollect/delete/${params.userId}/${params.baseId}/${params.baseType}`, params)

const userDbindEmailOpenId = (params) => apiGet(`/api/openapi/wx/userDbindEmailOpenId`, params)
// 隐私协议书
const dataDictionary = (params) => apiGet('/api/openapi/wx/dataDictionary', params)

// 同意隐私协议
const checkAgreeUserOk = (userId, isShowAgree) => apiGet(`/api/system/agreerecord/userAuthorization/${userId}/${isShowAgree}`)

// 获取协议名字
const queryAgreeByUserId = (params) => apiGet(`/api/system/agreerecord/queryAgreeByUserId/${params.userId}/${params.type}`)
const dictionaryList = (params) => apiGet(`/api/sys/data/dictionary/drop/down/list`, params)

// 获取服务器时间
const getServerTime = () => apiGet(`/api/sys/time/now`)

// 智能搜索时长上报
const updateSearchDuration = (params) => apiGet(`/api/userSearchLog/updateSearchDuration`, params)

// 获取年报数据
const getAnnualReport = (year, openId) => apiGet(`/api/yearreport/${year}/${openId}`)
// 获取年报第一页数据（注册排名）
const getRegisterRank = (openId) => apiGet(`/api/yearreport/registerRank/${openId}`)
export {
  systemRedisGet,
  systemRedisSet,
  systemRedisDelete,
  getQrCode,
  login,
  sourceShare,
  loginAuthUrl,
  getIsJinxiuAuthNew,
  appealRecord,
  uploadFile,
  sysFiles,
  queryPermissionsByUser,
  getBanner,
  getDatabaseCoursesDetail,
  getBarrage,
  sendBarrage,
  postVideoRecords,
  getStudyOverview,
  getStudyMap,
  videoFeedbacks,
  sendFeedback,
  getJourneyUpdateData,
  modifyPopupState,
  getJourneyStageData,
  getJourneyReport,
  getStageTask,
  getActivityList,
  getDaily,
  getIsCorrect,
  questionUser,
  getLiveList,
  liveMake,
  liveGetInfoById,
  getUserAESCode,
  getUserAESCodeV2,
  selectActivityRead,
  selectReportsRead,
  updateIsRead,
  homeSearch,
  homeSearchAI,
  getListBylakehouseId,
  homeRecommend,
  homeHot,
  homeNewest,
  recommendTips,
  similarRecommend,
  getLearningReport,
  iepXxbCaseMessages,
  updateIepXxbCaseMessagesIsRead,
  iepLogout,
  barrageList,
  getAifvPushRecordIsRead,
  userCollect,
  cancelUserCollect,
  userDbindEmailOpenId,
  dataDictionary,
  checkAgreeUserOk,
  queryAgreeByUserId,
  dictionaryList,
  updateSearchDuration,
  getServerTime,
  getAnnualReport,
  getRegisterRank
}



// WEBPACK FOOTER //
// ./src/api/api.js